var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"decision-glue"},[(_vm.work)?_c('div',_vm._l((_vm.work.answers),function(answer){return _c('div',{key:answer.id},[_c('glue-item',{attrs:{"decision":answer,"check":_vm.check(answer)}})],1)}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }